import { ChoicePicker, ChoicePickerOption } from "./ChoicePicker";
import { useTranslation } from "react-i18next";


interface DigitalFormatPickerProps {
    setDigitalFormat: (data: any) => void;
    required?: boolean;
    value: DigitalFormatOption[] | undefined;
}

export interface DigitalFormatOption extends ChoicePickerOption {
    id: string;
    name: string
}

export const DigitalFormatPicker = (props: DigitalFormatPickerProps) => {
    const { t } = useTranslation();
    
    const data: ChoicePickerOption[] = [
        {id: "display", name: t("txt_digital_format_display")},
        {id: "i/ostream", name: t("txt_digital_format_i/ostream")},
        {id: "audio", name: t("txt_digital_format_audio")},
        {id: "native-adds", name: t("txt_digital_format_native-adds")},
        {id: "social", name: t("txt_digital_format_social")},
        {id: "stories", name: t("txt_digital_format_stories")},
    ]

    return (
        <ChoicePicker
            setSelectedData={props.setDigitalFormat}
            placeholder={t("txt_digital_format")}
            data={data}
            multiple={true}
            required={props.required}
            controlId="digitalFormatPicker"
            value={props.value ? props.value : []}
        />
);
}